export default __webpack_public_path__ + "static/media/icon__15.a83ddccc.svg";